import {getNumberFromInput} from '../../../record-editing';
import {
    LabelContainer,
    Label,
    NumberControlShowingEdits,
    ValidationsList,
    RequiredSignifier
} from '../../../components/Form/FormStyles';
import {ValidateControl} from '../../../components/Controls/ValidateControl';
import {EditedProject} from '../EditedProject';
import {NumericFormFieldContainer} from './NumericFormFieldContainer';

export function CommunityTreesPlantedControl({
    project,
    setProjectAndValidate
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
    isRequired?: boolean;
}) {
    return (
        <NumericFormFieldContainer>
            <LabelContainer>
                {!project.ControlledByAutomation && (
                    <ValidateControl
                        validated={project.CommunityTreesPlantedValidated.current}
                        disabled={project.CommunityTreesPlanted.notValidToShowPartner}
                        onChange={(e) =>
                            setProjectAndValidate({
                                ...project,
                                CommunityTreesPlantedValidated:
                                    project.CommunityTreesPlantedValidated.update(e.validated)
                            })
                        }
                    />
                )}
                <Label htmlFor="eventTreesPlanted">Trees planted</Label>
                <RequiredSignifier />
            </LabelContainer>
            <NumberControlShowingEdits
                id="eventTreesPlanted"
                disabled={project.ControlledByAutomation}
                value={project.CommunityTreesPlanted}
                onChange={(e) =>
                    setProjectAndValidate({
                        ...project,
                        CommunityTreesPlanted: project.CommunityTreesPlanted.update(
                            getNumberFromInput(e)
                        )
                    })
                }></NumberControlShowingEdits>
            <ValidationsList validations={project.CommunityTreesPlanted.validations} />
        </NumericFormFieldContainer>
    );
}
